import { Store } from '@ngrx/store';
import { Component, signal, Output, EventEmitter, input, model, WritableSignal, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KENDO_COMBOBOX } from "@progress/kendo-angular-dropdowns";
import { ControlsModule } from '@pmis3/ui-controls';
import { KENDO_DIALOGS } from '@progress/kendo-angular-dialog';
import { IconsModule } from '@progress/kendo-angular-icons';
import { KENDO_BUTTONS } from "@progress/kendo-angular-buttons";
import { IVesselStop } from '@pmis3/vessel-activity-core';
import { KENDO_INPUTS } from "@progress/kendo-angular-inputs";
import { KENDO_LABEL } from "@progress/kendo-angular-label";

@Component({
    selector: 'pmis3-vessel-visit-detail-movement-service-application-picker-button',
    standalone: true,
    imports: [CommonModule, ControlsModule, KENDO_COMBOBOX, KENDO_DIALOGS, KENDO_BUTTONS, IconsModule, KENDO_INPUTS, KENDO_LABEL],
    templateUrl: 'vessel-visit-detail-movement-service-application-picker-button.component.html',
    styleUrl: "vessel-visit-detail-movement-service-application-picker-button.component.scss"
})
export class VesselVisitDetailMovementServiceApplicationPickerButtonComponent {
    isSelected = model.required<boolean | undefined>();
    label = input.required<string>();
    icon = input.required<string>();

    @Output() isSelectedChange = new EventEmitter<boolean>();
    
    toggleSelection() {
        this.isSelected.set(!this.isSelected())
        this.isSelectedChange.emit(this.isSelected())
    }
}   